import { handleError } from "../error";
import { SET_AUTOMOBILE_DATA } from "../../types";
export const updateContacts = event => async(dispatch, getState) => {
    try {
        const { automobiles: { automobileData } } = getState();
        const { name, value } = event.target;

        const newAutomobileData = {
            ...automobileData,
            contact_list: {
                ...automobileData.contact_list,
                [name]: value
            }
        };
        console.debug({ newAutomobileData });
        dispatch({
            type: SET_AUTOMOBILE_DATA,
            payload: newAutomobileData
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const setStaticContacts = () => async(dispatch, getState) => {
    try {
        const {
            automobiles: {
                contacts: { contact_dropdowns },
                automobileData
            }
        } = getState();
        let newAutomobileData = { ...automobileData };

        const contact_list = Object.keys(newAutomobileData.contact_list);

        /*
            Setting static contact name - phone - email to different tabs on both properties
            and vehicles. switch and case is checking for typeId `contact_type.id`. Backend is
            using contact type id for object keys. This logic will triggers onLoad and potential
            on switching tabs.
        */
        contact_list.forEach(typeId => {
            switch (typeId) {
                case "13": {
                    const selectedContact = contact_dropdowns[typeId].find(
                        ({ id }) => String(id) === String(newAutomobileData.contact_list[typeId])
                    );
                    newAutomobileData.asset_manager_name =
                        selectedContact.name;
                    newAutomobileData.asset_manager_phone =
                        selectedContact.phone_number ||
                        selectedContact.mobile_number;
                    newAutomobileData.asset_manager_email =
                        selectedContact.email;

                    break;
                }
                case "36": {
                    const selectedContact = contact_dropdowns[typeId].find(
                        ({ id }) => String(id) === String(newAutomobileData.contact_list[typeId]));
                    newAutomobileData.selling_agent_name =
                        selectedContact.name;
                    newAutomobileData.selling_agent_phone =
                        selectedContact.phone_number ||
                        selectedContact.mobile_number;
                    newAutomobileData.selling_agent_email =
                        selectedContact.email;

                    break;
                }
                default:
                    break;
            }
        });

        dispatch({
            type: SET_AUTOMOBILE_DATA,
            payload: newAutomobileData
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};